/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NaturalPersonDetails
 */
export interface NaturalPersonDetails {
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    idNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    passportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    mobileNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    ficaStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    physicalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    workTelephone?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    homeTelephone?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    nationalityCountry?: string;
    /**
     * 
     * @type {Date}
     * @memberof NaturalPersonDetails
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    residenceCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    maritalStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    postalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    employmentStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDetails
     */
    sourceOfMoney?: string;
}

/**
 * Check if a given object implements the NaturalPersonDetails interface.
 */
export function instanceOfNaturalPersonDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NaturalPersonDetailsFromJSON(json: any): NaturalPersonDetails {
    return NaturalPersonDetailsFromJSONTyped(json, false);
}

export function NaturalPersonDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalPersonDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'idNumber': !exists(json, 'IdNumber') ? undefined : json['IdNumber'],
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'mobileNumber': !exists(json, 'MobileNumber') ? undefined : json['MobileNumber'],
        'taxNumber': !exists(json, 'TaxNumber') ? undefined : json['TaxNumber'],
        'ficaStatus': !exists(json, 'FicaStatus') ? undefined : json['FicaStatus'],
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : json['PhysicalAddress'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'workTelephone': !exists(json, 'WorkTelephone') ? undefined : json['WorkTelephone'],
        'homeTelephone': !exists(json, 'HomeTelephone') ? undefined : json['HomeTelephone'],
        'nationalityCountry': !exists(json, 'NationalityCountry') ? undefined : json['NationalityCountry'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'residenceCountry': !exists(json, 'ResidenceCountry') ? undefined : json['ResidenceCountry'],
        'maritalStatus': !exists(json, 'MaritalStatus') ? undefined : json['MaritalStatus'],
        'postalAddress': !exists(json, 'PostalAddress') ? undefined : json['PostalAddress'],
        'employmentStatus': !exists(json, 'EmploymentStatus') ? undefined : json['EmploymentStatus'],
        'industry': !exists(json, 'Industry') ? undefined : json['Industry'],
        'sourceOfMoney': !exists(json, 'SourceOfMoney') ? undefined : json['SourceOfMoney'],
    };
}

export function NaturalPersonDetailsToJSON(value?: NaturalPersonDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Title': value.title,
        'Name': value.name,
        'Surname': value.surname,
        'IdNumber': value.idNumber,
        'PassportNumber': value.passportNumber,
        'Email': value.email,
        'MobileNumber': value.mobileNumber,
        'TaxNumber': value.taxNumber,
        'FicaStatus': value.ficaStatus,
        'PhysicalAddress': value.physicalAddress,
        'Country': value.country,
        'WorkTelephone': value.workTelephone,
        'HomeTelephone': value.homeTelephone,
        'NationalityCountry': value.nationalityCountry,
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'ResidenceCountry': value.residenceCountry,
        'MaritalStatus': value.maritalStatus,
        'PostalAddress': value.postalAddress,
        'EmploymentStatus': value.employmentStatus,
        'Industry': value.industry,
        'SourceOfMoney': value.sourceOfMoney,
    };
}

